
    import './styles.scoped.css';
    export default {
  "options-list": "awsui_options-list_19gcf_zkwr5_141",
  "options-list-embedded": "awsui_options-list-embedded_19gcf_zkwr5_188",
  "decrease-block-margin": "awsui_decrease-block-margin_19gcf_zkwr5_195"
};
  